import { X } from 'lucide-react'
import { type ComponentPropsWithoutRef } from 'react'

import { Button } from '#app/components/ui/button.tsx'
import { cn } from '#app/utils/misc.tsx'

type Props = {
	onClick: NonNullable<ComponentPropsWithoutRef<typeof Button>['onClick']>
	disabled?: boolean
	ariaLabel?: string
	className?: string
}

export function RemoveButton({
	onClick,
	disabled,
	ariaLabel = 'Remove item',
	className,
}: Props) {
	if (disabled) {
		return null
	}

	return (
		<Button
			type="button"
			variant="ghost"
			size="icon"
			onClick={onClick}
			aria-label={ariaLabel}
			className={cn(
				'size-4 text-red-600 hover:text-red-600 focus-visible:text-red-600',
				className,
			)}
		>
			<X className="h-3.5 w-3.5" aria-hidden="true" />
		</Button>
	)
}
